module.exports = __webpack_public_path__ + "static/media/brujula_cervecistas.86069401.svg";